import React from 'react';
import PropTypes from 'prop-types';

const ItemsSummary = ({ basket, items, onRemoveAll }) => {
  if (!items || !items.length) {
    return null;
  }

  const hasQuantity = Boolean(basket.numberOfItems);

  return (
    <div className="hd-trolleyMenu__itemsSummary">
      <span className="hd-trolleyMenu__itemsSummaryLabel">{basket.numberOfItems} items</span>
      {hasQuantity && (
        <button
          className="btn-tertiary hd-trolleyMenu__btnRemoveAll"
          onClick={onRemoveAll}
        >
          Remove all items
        </button>
      )}
    </div>
  );
};

ItemsSummary.propTypes = {
  basket: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  onRemoveAll: PropTypes.func.isRequired,
};

export default ItemsSummary;
